"use client";

import Link from "next/link";
import { useState } from "react";

import { MobileNavigation } from "~/components/MobileNavigation";
import { Button } from "~/components/ui/button";
import type { SiteLocale } from "~/lib/graphql";

interface NavigationItem {
  slug: string;
  shortTitle: string;
}

interface HeaderProps {
  locale: SiteLocale;
  showNavigation?: boolean;
  navigationItems?: NavigationItem[];
}

export default function Header({
  locale,
  showNavigation = false,
  navigationItems = [],
}: HeaderProps) {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <>
      <div className="">
        <header className="absolute z-40 container mx-auto flex h-16 max-w-[1440px] items-center justify-end px-0 lg:left-1/2 lg:-translate-x-1/2">
          {/* Mobile burger menu */}
          {showNavigation && navigationItems.length > 0 && (
            <Button
              variant="ghost"
              size="icon"
              className="absolute top-4 left-4 z-50 h-12 w-12 bg-white/10 backdrop-blur-sm hover:bg-white/20 lg:hidden [&_svg]:size-8"
              onClick={() => setIsMobileNavOpen(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="none"
                viewBox="0 0 32 32"
                className="h-10 w-10"
              >
                <circle cx="16" cy="16" r="15.5" fill="#fff" stroke="#8C9091"></circle>
                <path
                  stroke="#8C9091"
                  strokeLinecap="round"
                  strokeWidth="2"
                  d="M9 9.581h14M9 16h14M9 22.419h14"
                ></path>
              </svg>
            </Button>
          )}

          {/* {showNavigation && navigationItems.length > 0 && (
            <nav className="hidden items-center space-x-6 ">
              {navigationItems.map((item, index) => (
                <Link
                  key={item.slug + index}
                  href={`#${item.slug}`}
                  className="text-sm font-medium text-white transition-colors hover:text-white/80"
                >
                  {item.shortTitle}
                </Link>
              ))}
            </nav>
          )} */}

          <div className="text-eurac-grey-60 mr-5 flex items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="20"
              viewBox="0 0 30 20"
              fill="none"
            >
              <g clipPath="url(#clip0_2325_184)">
                <path
                  opacity="0.7"
                  d="M8.41653 5.52344H6.79443L3.55127 16.065H5.17338L5.92326 13.6329H9.29192L10.0376 16.065H11.6597L8.41653 5.52344ZM6.42212 12.0098L7.60548 8.15382L8.79306 12.0098H6.42212Z"
                  fill="#666B6C"
                />
                <path
                  opacity="0.7"
                  d="M20.3156 3.18628H21.9377V4.80839H20.3156V3.18628ZM25.1808 13.7279C23.7 13.7408 22.2321 13.4512 20.8672 12.8767C19.6806 13.4392 18.3835 13.7299 17.0703 13.7279V12.1058C17.756 12.1074 18.4385 12.0118 19.0974 11.822C18.4939 11.3902 17.9974 10.8258 17.646 10.1722C17.2946 9.51857 17.0977 8.79312 17.0703 8.05154H18.6924C18.7576 8.69467 18.9914 9.30921 19.3701 9.8331C19.7488 10.357 20.259 10.7717 20.8493 11.0352C21.6563 10.5624 22.3291 9.89099 22.8035 9.08484C23.2779 8.27868 23.5383 7.36458 23.5598 6.42944H17.0735V4.80839H25.1819V6.43049C25.1694 7.45312 24.9315 8.4604 24.485 9.38051C24.0385 10.3006 23.3946 11.1109 22.599 11.7535C23.4396 11.9894 24.3088 12.1079 25.1819 12.1058L25.1808 13.7279Z"
                  fill="#666B6C"
                />
                <path
                  opacity="0.7"
                  d="M29.7643 0H11.7239L11.7576 2.56183H0V20H17.3485V17.4688L29.7643 17.435V0ZM16.5385 19.19H0.811053V3.36972H11.8009L16.5385 17.2325V19.19ZM28.9543 16.6292L17.2019 16.6609L12.5729 2.85292L12.5455 0.809998H28.9543V16.6292Z"
                  fill="#666B6C"
                />
              </g>
              <defs>
                <clipPath id="clip0_2325_184">
                  <rect width="29.7643" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Link
              href="/en"
              className={`border-eurac-grey-60 flex h-6 w-6 items-center justify-center space-x-2 rounded-full border text-[10px] font-medium ${locale === "en" ? "bg-eurac-grey-60 text-white" : "hover:bg-eurac-grey-60 hover:text-white"}`}
            >
              EN
            </Link>

            <Link
              href="/it"
              className={`border-eurac-grey-60 flex h-6 w-6 items-center justify-center space-x-2 rounded-full border text-[10px] font-medium ${locale === "it" ? "bg-eurac-grey-60 text-white" : "hover:bg-eurac-grey-60 hover:text-white"}`}
            >
              IT
            </Link>
            <Link
              href="/de"
              className={`border-eurac-grey-60 flex h-6 w-6 items-center justify-center space-x-2 rounded-full border text-[10px] font-medium ${locale === "de" ? "bg-eurac-grey-60 text-white" : "hover:bg-eurac-grey-60 hover:text-white"}`}
            >
              DE
            </Link>
          </div>
        </header>
      </div>

      {/* Mobile Navigation Modal */}
      <MobileNavigation
        navigationItems={navigationItems}
        isOpen={isMobileNavOpen}
        onClose={() => setIsMobileNavOpen(false)}
      />
    </>
  );
}
